// modules
import { addModal, closeCurrentModal } from 'weblite-web-modal-viewer'
import { SelectWorkspace } from './select-workspace'

const COMPONENT_ID = 'selectWorkspace'

const showSelectMenu = (props: Parameters<typeof SelectWorkspace>[0]) =>
  addModal({ id: COMPONENT_ID, props })

export const showSelectWorkspace = (
  onSelect: (workspaceId: string, workspaceName: string) => unknown,
) =>
  showSelectMenu({
    onSelect: (workspaceId: string, workspaceName: string) => {
      onSelect(workspaceId, workspaceName)
      closeCurrentModal()
    },
  })

export default {
  [COMPONENT_ID]: {
    Component: SelectWorkspace,
  },
}
